module.exports = __webpack_public_path__ + "static/1inch-e6453411ac75421b66c2a942b3b11468.png";